import styled from "styled-components"

export default styled.hr`
    background: #F1F3FF;
    width: 100%;
    height: 2px;
    border: 0;
`
